// import React, { useState } from "react";
// import SideMenuHOD from "../components/SideMenuHOD";
// import Header from "../components/Header";

// import mainPic from "../assets/images/Rectangle 626.png";
// import imgDocs from "../assets/images/Group 1000003697.png";
// import imgChart from "../assets/images/Frame 71.png";

// const ChallanDetails = () => {
//   const [reportType, setReportType] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);

//   const handleDownload = () => {
//     console.log({ reportType, fromDate, toDate });
//   };

//   return (
//     <div className="flex h-screen overflow-hidden">
//       <SideMenuHOD
//         isOpen={isSidebarOpen}
//         onClose={() => setIsSidebarOpen(false)}
//       />

//       <div className="flex flex-col flex-1 overflow-y-auto bg-gray-50">
//         <Header onMenuToggle={() => setIsSidebarOpen((v) => !v)} />

//         <main className="p-4 md:p-8">
//           {/* Banner */}
//           <div className="mb-8">
//             <img
//               src={mainPic}
//               alt="Banner"
//               className="w-full h-40 md:h-56 object-cover rounded-lg shadow"
//             />
//           </div>

//           <div className="flex flex-col md:flex-row items-start md:items-center gap-8">
//             {/* Form */}

//             <div className="bg-white border border-gray-200 rounded-lg shadow p-6 w-full md:w-1/3">
//               <h2 className="text-xl font-semibold mb-6">Comparison Data</h2>
//               <div className="space-y-4">
//                 {/* REPORT TYPE */}
//                 <div className="relative">
//                   <select
//                     id="reportType"
//                     required
//                     value={reportType}
//                     onChange={(e) => setReportType(e.target.value)}
//                     className={`
//         peer block w-full rounded border border-gray-300 bg-white
//         py-3 px-3 text-base appearance-none
//         focus:outline-none focus:border-blue-500
//       `}
//                   >
//                     <option value="" disabled hidden>
//                       Select Report
//                     </option>
//                     <option value="revenue">Revenue Comparison</option>
//                     <option value="documents">Document Count</option>
//                     <option value="top-deeds">Top Deeds</option>
//                   </select>
//                   <label
//                     htmlFor="reportType"
//                     className={`
//         absolute left-3 bg-white px-1 transition-all
//         peer-invalid:top-1/2 peer-invalid:-translate-y-1/2 peer-invalid:text-base peer-invalid:text-gray-500
//         peer-valid:top-0 peer-valid:-translate-y-1/2 peer-valid:text-xs peer-valid:text-gray-700
//         peer-focus:top-0 peer-focus:-translate-y-1/2 peer-focus:text-xs peer-focus:text-blue-500
//       `}
//                   >
//                     Report Type
//                   </label>
//                 </div>

//                 {/* FROM DATE */}
//                 <div className="relative">
//                   <input
//                     id="fromDate"
//                     type="date"
//                     required
//                     value={fromDate}
//                     onChange={(e) => setFromDate(e.target.value)}
//                     className={`
//       block w-full rounded border border-gray-300 bg-white
//       py-3 px-3 text-base focus:outline-none focus:border-blue-500
//     `}
//                   />
//                   <label
//                     htmlFor="fromDate"
//                     className={`
//       absolute left-3 bg-white px-1 transition-all top-0 -translate-y-1/2 text-xs text-gray-700
//     `}
//                   >
//                     From Date
//                   </label>
//                 </div>

//                 {/* TO DATE */}
//                 <div className="relative">
//                   <input
//                     id="toDate"
//                     type="date"
//                     required
//                     value={toDate}
//                     onChange={(e) => setToDate(e.target.value)}
//                     className={`
//       block w-full rounded border border-gray-300 bg-white
//       py-3 px-3 text-base focus:outline-none focus:border-blue-500
//     `}
//                   />
//                   <label
//                     htmlFor="toDate"
//                     className={`
//       absolute left-3 bg-white px-1 transition-all top-0 -translate-y-1/2 text-xs text-gray-700
//     `}
//                   >
//                     To Date
//                   </label>
//                 </div>

//                 <button
//                   onClick={handleDownload}
//                   className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 rounded transition"
//                 >
//                   Download Report
//                 </button>
//               </div>
//             </div>

//             {/* Illustration + Text + Chart */}

//             <div className="flex flex-col md:flex-row items-start justify-start gap-4 md:gap-6 m-2">
//               {/* left: docs illustration */}
//               <img
//                 src={imgDocs}
//                 alt="Documents Illustration"
//                 className="w-20 h-20 md:w-28 md:h-28"
//               />

//               {/* right: heading + (paragraph + icon) */}
//               <div className="flex flex-col max-w-md">
//                 <h3 className="text-2xl font-bold mb-2">
//                   Filter, Find, and Download in Seconds
//                 </h3>

//                 <div className="flex items-start gap-4">
//                   <p className="text-gray-600">
//                     Use smart filters and tags to download any report instantly
//                     — no matter how old or detailed.
//                   </p>
//                   <img
//                     src={imgChart}
//                     alt="Chart Icon"
//                     className="w-16 h-16 md:w-16 md:h-16"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </main>
//       </div>
//     </div>
//   );
// };

// export default ChallanDetails;

import React, { useState, useEffect } from "react";

import ReportLayout from "../components/ReportLayout";
import { DateField } from "../components/DateField";
import { SelectField } from "../components/SelectField";

import API_BASE_URL from "../utilities/ApiConfig";
import axios from "axios";

export default function ChallanDetails() {
  const [form, setForm] = useState({
    fromDate: "",
    toDate: "",
    district: "",
    sro: "",
  });
  const [districts, setDistricts] = useState([]);
  const [sros, setSros] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/Master/get_District_Mas`)
      .then((res) => setDistricts(res.data.data));
  }, []);
  useEffect(() => {
    if (form.district) {
      fetchSros(form.district);
    } else {
      setSros([]);
    }
  }, [form.district]);

  const fetchSros = async (dcode) => {
    const res = await axios.get(
      `${API_BASE_URL}/Master/get_sro_master_data?dcode=${dcode}`
    );
    setSros(res.data.data);
  };

  const handleChange = (field) => (e) =>
    setForm((f) => ({ ...f, [field]: e.target.value }));
  const handleDownload = () => console.log(form);

  return (
    <ReportLayout title="Challan Details" onDownload={handleDownload}>
      <DateField
        id="fromDate"
        label="From Date"
        value={form.fromDate}
        onChange={handleChange("fromDate")}
      />
      <DateField
        id="toDate"
        label="To Date"
        value={form.toDate}
        onChange={handleChange("toDate")}
      />
      <SelectField
        id="district"
        label="Select District"
        value={form.district}
        onChange={handleChange("district")}
        options={districts.map((d) => ({
          value: d.dcode,
          label: d.districtName,
        }))}
      />
      <SelectField
        id="sro"
        label="Select SRO"
        value={form.sro}
        onChange={handleChange("sro")}
        options={sros.map((s) => ({ value: s.srocode, label: s.sroname }))}
      />
    </ReportLayout>
  );
}
